import React, { memo } from "react";
import { Handle, NodeProps, Position } from "react-flow-renderer";
import useNodeToCenter from "./useNodeToCenter";
import * as S from "./styled";

export default memo<NodeProps<any>>(({ data, xPos, yPos, selected, isConnectable }) => {
  useNodeToCenter(xPos, yPos, data.highlight);

  return (
    <S.Node className="drag-handle" isSelected={selected || data.highlight}>
      <Handle
        id="a"
        type="target"
        position={Position.Left}
        style={{ top: "50%", left: -16, width: 12, height: 12, background: "#555" }}
        isConnectable={isConnectable}
      />

      <S.Label>TRIGGER BY PHRASE:</S.Label>
      <S.Select value={data.intent} onChange={(e) => data.update({ intent: e.target.value })}>
        {data.intents.length + data.entities.length == 0 && <option>No intents</option>}
        {data.intents.map((id) => (
          <option key={id}>{id}</option>
        ))}
        {data.entities.map((id) => (
          <option key={id}>{id}</option>
        ))}
      </S.Select>

      <label style={{ display: "flex", marginTop: 8, alignItems: "center" }}>
        <S.Label style={{ marginRight: 8 }}>Priority:</S.Label>
        <S.Input
          style={{ width: 50 }}
          type="number"
          value={data.priority}
          onChange={(e) => data.update({ priority: e.target.value })}
        />
      </label>

      <Handle
        id="b"
        type="source"
        position={Position.Right}
        style={{ top: "50%", right: -16, width: 12, height: 12, background: "#555" }}
        isConnectable={isConnectable}
      />
    </S.Node>
  );
});
